<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="expense-list-container" [class.dialog-mode]="isDialogMode">
  <!-- Close button - only show when opened as dialog -->
  @if (isDialogMode) {
    <button
      type="button"
      class="dialog-close-button"
      (click)="closeDialog()"
      aria-label="Close dialog">
      <i class="pi pi-times"></i>
    </button>
  }
  @if (properties?.length > 0) {
    <p-table dataKey="expenseId" editMode="row" [editField]="editingExpense" class="expense-table" #pt [value]="expenses" [lazy]="true"
      (onLazyLoad)="loadLazy($event)" dataKey="expenseId" selectionMode="multiple" [(selection)]="selectedExpenses" [contextMenuSelection]="selectedExpenses"
      (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
      (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
      [loading]="loading" [paginator]="showPagination" [rows]="100"
      [rowsPerPageOptions]="[100,200,300,400,500,600,700,800,900,1000,1500,2000,2500,3000,4500,6000,100000]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
      [totalRecords]="recordTotal" sortMode="multiple" [multiSortMeta]="multiSortMeta"
      styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true" [autoLayout]="true"
      [responsive]="true" showJumpToPageInput="true">
      <ng-template pTemplate="caption">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <h1 style="margin: 6px;">Expenses</h1>
            <button pButton pRipple class="p-button-text p-button-sm"
              style="font-size: 80%;"
            (click)="onAdvanceSearch()">Advanced Search</button>
          </div>
          <div>
            <!-- Bulk Edit Button - Show when rows are selected but not in edit mode -->
            @if (selectedExpenses?.length > 0 && editingExpenseIds?.length === 0) {
              <p-splitButton
                label="Bulk Edit"
                icon="pi pi-pencil"
                [model]="bulkEditMenuItems"
                (onClick)="onBulkEditClick()"
                styleClass="p-button-sm"
                [disabled]="selectedExpenses?.length === 0">
              </p-splitButton>
            }
            <!-- Save/Cancel Buttons - Show when rows are in edit mode -->
            @if (editingExpenseIds?.length > 0) {
              <button
                pButton pRipple
                type="button"
                icon="pi pi-check"
                [label]="editingExpenseIds?.length > 1 ? ('Save All (' + editingExpenseIds?.length + ')') : 'Save'"
                class="p-button-primary p-button-sm"
                (click)="onMultipleRowsSave()">
              </button>
            }
            @if (editingExpenseIds?.length > 0) {
              <button
                pButton pRipple
                type="button"
                label="Cancel"
                icon="pi pi-times"
                class="p-button-danger p-button-sm ml-2"
                (click)="onCancelEditAndSelection()">
              </button>
            }
            <!-- Cancel Button - Show when rows are selected but not in edit mode -->
            @if (selectedExpenses?.length > 0 && editingExpenseIds?.length === 0) {
              <button
                pButton pRipple
                type="button"
                label="Cancel"
                icon="pi pi-times"
                class="p-button-danger p-button-sm ml-2"
                (click)="onCancelEditAndSelection()">
              </button>
            }
          </div>
          @if (!isDialogMode) {
            <div class="d-flex gap-2">
              <div>
                <!--clear filters-->
                @if (showFilter) {
                  <button pButton pRipple class="p-button-text"
                    style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;" (click)="reloadPage()">Clear
                  Filters</button>
                }
                <!--add new-->
                @if (!outlineNewButton) {
                  <button pButton pRipple class="p-button-outlined"
                  style="padding: 0.643rem 0.75rem !important;" (click)="onOpenFormAdd()">New Expense +</button>
                }
                @if (outlineNewButton) {
                  <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
                  (click)="onOpenFormAdd()">New Expense +</button>
                }
                <app-import-export importEnabled="false" [dataRetrived]="expenses" (exportDataSelected)="exportAsExcelFile($event)"
                [columns]="columns" [importDisabled]="true" [exportLoading]="exportLoading"></app-import-export>
              </div>
              <div class="d-flex flex-column justify-content-center" style="min-width: 220px; text-align: right;">
                <div class="small text-muted">prevFireTime: {{ formatAutoPayFireTime(autoPayFireTimes?.prevFireTime) }}</div>
                <div class="small text-muted">nextFireTime: {{ formatAutoPayFireTime(autoPayFireTimes?.nextFireTime) }}</div>
              </div>
              <div class="d-flex align-items-center">
                @if (isTasksSyncing) {
                  <button pButton pRipple type="button" class="p-button-sm"><i class="pi pi-spinner pi-spin"></i> Syncing tasks to Breezeway...</button>
                }
                @if (!isTasksSyncing) {
                  <p-buttongroup>
                    <button pButton pRipple type="button" [disabled]="isTasksSyncing" (click)="syncAllTasksToBreezwayLast45Days()" label="Sync Breezeway tasks (Last 45 days)" icon="pi pi-refresh" class="p-button-sm"></button>
                    <button pButton pRipple type="button" label="Custom" icon="pi pi-calendar" class="p-button-sm border-left-1"
                    (click)="openSyncBreezewayCustomDialog()" [disabled]="isTasksSyncing"></button>
                  </p-buttongroup>
                }
              </div>
            </div>
          }
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th [style]="{'width': '3rem'}" pFrozenColumn>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          @for (col of displayColumns; track col) {
            @if (col.showSort) {
              <th class="text-nowrap" [class.task-col-header]="col.field === 'name'" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            } @else {
              <th class="text-nowrap" [class.task-col-header]="col.field === 'name'">
                {{col.header}}
              </th>
            }
          }
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
        @if (showFilter) {
          <tr>
            <th [ngStyle]="{'width': '3rem'}"></th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
            type="text" (input)="pt.filter($event.target.value, 'expenseId', 'in')"></th>
            <th>
              <p-multiSelect #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="shortTermRentalId"
                [options]="properties" appendTo="body" defaultLabel="Property Code"
                (onChange)="pt.filter($event.value, 'shortTermRentalId', 'in')" styleClass="p-column-filter"
                placeholder="Filter" [showClear]="true" optionLabel="propertyCode"
                optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false">
                <ng-template let-option pTemplate="item">
                  <span>{{option.propertyCode}}</span>
                </ng-template>
              </p-multiSelect>
            </th>
            <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th> -->
            <th [ngStyle]="{'width': 'auto'}">
              <p-calendar [(ngModel)]="expenseDateRange" appendTo="body" showButtonBar="true"
                selectionMode="range" placeholder="Select Date Range" (onClose)="onExpenseDateRangeChange()"
                [style]="{'width':'100%','min-width':'200px'}" dateFormat="mm-dd-yy">
              </p-calendar>
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <p-calendar [(ngModel)]="stmtBilledDateRange" appendTo="body" showButtonBar="true"
                selectionMode="range" placeholder="Select Date Range" (onClose)="onStmtBilledDateRangeChange()"
                [style]="{'width':'100%','min-width':'200px'}" dateFormat="mm-dd-yy">
              </p-calendar>
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <p-dropdown [options]="showToStmtOptions" [(ngModel)]="showToStmt" optionLabel="name" optionValue="value" appendTo="body" (onChange)="pt.filter($event.value, 'showToStmt', 'in')">
                <ng-template let-option pTemplate="item">
                  <span>{{option.name}}</span>
                </ng-template>
              </p-dropdown>
            </th>
            <th [ngStyle]="{'width': 'auto'}"><p-multiSelect [options]="expenseService.statuses" defaultLabel="Status"
            optionLabel="name" (onChange)="pt.filter($event.value, 'status', 'in')" appendTo="body"></p-multiSelect></th>
            <th [ngStyle]="{'width': 'auto'}">
              <p-multiSelect [options]="expenseService.expenseCategories" defaultLabel="Category" optionLabel="name"
              (onChange)="pt.filter($event.value, 'expenseCategory', 'in')" appendTo="body"></p-multiSelect>
            </th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
            (input)="pt.filter($event.target.value, 'name', 'in')"></th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'paidByKbm', 'in')"> -->
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'paidByOwner', 'in')"> -->
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'expenseAmount', 'in')"> -->
            </th>
            @if (forReconciliation) {
              <th [ngStyle]="{'width': 'auto'}">
                <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
                (input)="pt.filter($event.target.value, 'discrepancyAmount', 'in')"> -->
              </th>
            }
            @if (forReconciliation) {
              <th [ngStyle]="{'width': 'auto'}">
                <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
                (input)="pt.filter($event.target.value, 'stmtExpenseAmount', 'in')"> -->
              </th>
            }
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'laborPaidByKBM', 'in')"> -->
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'laborPaidByOwner', 'in')"> -->
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'materialsPaidByKBM', 'in')"> -->
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'materialsPaidByOwner', 'in')"> -->
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'thirdPartExpenseByKBM', 'in')"> -->
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
              (input)="pt.filter($event.target.value, 'thirdPartExpenseByOwner', 'in')"> -->
            </th>
            <!-- <th [ngStyle]="{'width': 'auto'}"><p-multiSelect [options]="expenseService.priorities"
            defaultLabel="Priority" optionLabel="name"
          (onChange)="pt.filter($event.value, 'priority', 'in')" appendTo="body"></p-multiSelect></th> -->
          <th [ngStyle]="{'width': '250px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
          type="text" (input)="pt.filter($event.target.value, 'assignedToName', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-multiSelect #bb [style]="{'width':'50px','min-width':'100%'}"
              [options]="expenseVendors" appendTo="body" defaultLabel="Vendor" optionLabel="name" optionValue="value" [style]="{'width':'100%'}"
              (onChange)="pt.filter($event.value, 'expenseVendor', 'in')" styleClass="p-column-filter"
              placeholder="Select Vendor" [showClear]="true" [filter]="true" filterBy="name">
            </p-multiSelect>
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'expenseVendorId', 'in')">
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <!-- <p-calendar appendTo="body" showButtonBar="true"
            placeholder="Select Date" (onSelect)="onDateSelect($event, 'createDate')"
            [style]="{'width':'100%','min-width':'200px'}" dateFormat="mm-dd-yy">
          </p-calendar> -->
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <!-- <p-calendar appendTo="body" showButtonBar="true"
          placeholder="Select Date" (onSelect)="onDateSelect($event, 'lastUpdate')"
          [style]="{'width':'100%','min-width':'200px'}" dateFormat="mm-dd-yy">
        </p-calendar> -->
      </th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-expense let-rowIndex="rowIndex">
  <tr [pSelectableRow]="expense" [pEditableRow]="isRowEditable(expense) ? expense : null"
    (contextmenu)="onRowContextMenu($event, contextMenu, expense)"
    (click)="onRowClick($event, expense)"
    (dblclick)="onRowDoubleClick($event, expense)"
    [attr.data-expense-id]="expense.expenseId"
    [class.row-editing]="editingExpenseIds.includes(expense.expenseId)"
    [ngClass]="getReconciliationRowClass(expense)">
    <td (click)="$event.stopPropagation()" pFrozenColumn>
      <p-tableCheckbox [value]="expense"></p-tableCheckbox>
    </td>
    <td>{{expense.expenseId}} </td>
    <td>{{getPropertyCode(expense?.shortTermRentalId)}} </td>
    <td>{{toLocal(expense.expenseDate) | date:'MM-dd-yyyy'}}</td>
    <td>
      <p-cellEditor>
        <ng-template pTemplate="input">
          <p-calendar [(ngModel)]="expense.stmtBilledDate" appendTo="body" showButtonBar="true"
            selectionMode="single" placeholder="Select Date"
            [style]="{'width':'100%','min-width':'200px'}" dateFormat="mm-dd-yy">
          </p-calendar>
        </ng-template>
        <ng-template pTemplate="output">
          {{toLocal(expense.stmtBilledDate) | date:'MM-dd-yyyy'}}
        </ng-template>
      </p-cellEditor>
    </td>
    <td>
      <p-cellEditor>
        <ng-template pTemplate="input">
          <p-dropdown [(ngModel)]="expense.showToStmt" [options]="showToStmtOptionsWithoutAll" optionLabel="name" optionValue="value" appendTo="body" [style]="{'width':'100%'}"></p-dropdown>
        </ng-template>
        <ng-template pTemplate="output">
          <span [ngStyle]="{
            'display': 'inline-block',
            'padding': '2px 10px',
            'border-radius': '12px',
            'font-size': '12px',
            'font-weight': '600',
            'background-color': expense.showToStmt ? '#d4edda' : '#f8d7da',
            'color': expense.showToStmt ? '#155724' : '#721c24',
            'border': expense.showToStmt ? '1px solid #c3e6cb' : '1px solid #f5c6cb'
          }">
            {{ expense.showToStmt ? '✓ On Statement' : '✗ Off Statement' }}
          </span>
        </ng-template>
      </p-cellEditor>
    </td>
    <td>
      <p-cellEditor>
        <ng-template pTemplate="input">
          <p-dropdown [(ngModel)]="expense.status" [options]="statuses" optionLabel="name" optionValue="value" appendTo="body" [style]="{'width':'100%'}"></p-dropdown>
        </ng-template>
        <ng-template pTemplate="output">
          {{getStatus(expense)}}
        </ng-template>
      </p-cellEditor>
    </td>
    <td>
      <p-cellEditor>
        <ng-template pTemplate="input">
          <p-dropdown [(ngModel)]="expense.expenseCategory" [options]="expenseService.expenseCategories" optionLabel="name" optionValue="value" appendTo="body" [style]="{'width':'100%'}"></p-dropdown>
        </ng-template>
        <ng-template pTemplate="output">
          {{getExpenseCategory(expense)}}
        </ng-template>
      </p-cellEditor>
    </td>
    <td class="task-cell" [pTooltip]="expense.name" tooltipPosition="top" [title]="expense.name">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <textarea [style]="{minWidth: '100%'}" rows="2" pInputTextarea [autoResize]="true" [ngStyle]="{'min-width':'100%'}" pInputText type="text" [(ngModel)]="expense.name"></textarea>
        </ng-template>
        <ng-template pTemplate="output">
          <span class="task-cell-text">{{expense.name}}</span>
        </ng-template>
      </p-cellEditor>
    </td>
    <td>
      {{expense?.paidByKbm | statementAmount}}
    </td>
    <td>{{expense?.paidByOwner | statementAmount}}</td>
    <td>{{expense?.expenseAmount | statementAmount}}</td>
    @if (forReconciliation) {
      <td (click)="openStatement($event,expense)" class="link-text" pTooltip="View Statement" tooltipPosition="top">{{expense?.stmtExpSummaryAdmin?.expenseAmount ? (expense?.stmtExpSummaryAdmin?.expenseAmount | statementAmount) : '-'}}</td>
    }
    @if (forReconciliation) {
      <td (click)="openStatement($event,expense)" class="link-text" pTooltip="View Statement" tooltipPosition="top">{{(expense?.discrepancyAmount || 0) | statementAmount}}</td>
    }
    <td>{{expense?.laborPaidByKbm | statementAmount}}</td>
    <td>{{expense?.laborPadiByOwner | statementAmount}}</td>
    <td>{{expense?.materialsPaidByKbm | statementAmount}}</td>
    <td>{{expense?.materialsPaidByOwner | statementAmount}}</td>
    <td>{{expense?.thirdPartExpensePaidByKbm | statementAmount}}</td>
    <td>{{expense?.thirdPartExpensePaidByOwner | statementAmount}}</td>
    <!-- <td>{{getPriority(expense)}} </td> -->
    <td [pTooltip]="expense.assignedToName" tooltipPosition="top">{{expense?.assignedToName?.length > 20 ?
    expense.assignedToName.substring(0, 20) + '...' : expense.assignedToName}} </td>
    <td>{{getVendor(expense)}} </td>
    <td><a (click)="$event.stopPropagation();" href="{{expense.vendorReportUrl}}" target="_blank">{{expense.expenseVendorId}}</a> </td>
    <td>{{expense?.createDate | date:'MM-dd-yyyy'}}</td>
    <td>{{expense?.lastUpdate | date:'MM-dd-yyyy'}}</td>
    <td>
      <span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(expense)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
}
<p-contextMenu #contextMenu appendTo="body" [model]="contextMenuItems"></p-contextMenu>
</div>


<!-- Export Loading Dialog -->
<p-dialog [(visible)]="exportLoading" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [style]="{width: '450px'}" styleClass="export-loading-dialog" [baseZIndex]="10000">
  <div class="export-loading-content">
    <div class="spinner-container">
      <p-progressSpinner [style]="{width: '60px', height: '60px'}" strokeWidth="4" animationDuration=".8s">
      </p-progressSpinner>
    </div>

    <h2 class="dialog-title">Preparing Your Excel File</h2>

    <div class="message-container">
      <p class="main-message">
        <i class="pi pi-file-excel" style="font-size: 1.2rem; color: #217346; margin-right: 8px;"></i>
        Please wait while we prepare your Excel export...
      </p>
      <p class="creative-message">
        We're gathering all your expense data and organizing it just right for you!
      </p>
    </div>

    <div class="warning-container">
      <i class="pi pi-info-circle" style="font-size: 1rem; color: #f59e0b; margin-right: 8px;"></i>
      <span class="warning-text">Please don't refresh the page</span>
    </div>
  </div>
</p-dialog>

<!-- Bulk Edit Dialog (for Date and Name only) -->
<p-dialog [(visible)]="showBulkEditDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '500px'}" header="Bulk Edit Expenses" [baseZIndex]="10000">
  <div class="p-fluid">
    <div class="p-field" style="margin-bottom: 1rem;">
      <label>Selected Expenses: <strong>{{selectedExpenses?.length}}</strong></label>
    </div>

    @if (bulkEditField === 'stmtBilledDate') {
      <div class="p-field" style="margin-bottom: 1rem;">
        <label for="bulkStmtBilledDate">Stmt Billed Date</label>
        <p-calendar id="bulkStmtBilledDate" [(ngModel)]="bulkEditData.stmtBilledDate" appendTo="body"
          showButtonBar="true" selectionMode="single" placeholder="Select Date"
          [style]="{'width':'100%'}" dateFormat="mm-dd-yy">
        </p-calendar>
      </div>
    }

    @if (bulkEditField === 'name') {
      <div class="p-field" style="margin-bottom: 1rem;">
        <label for="bulkName">Name</label>
        <textarea id="bulkName" pInputTextarea [(ngModel)]="bulkEditData.name" rows="3" [style]="{'width':'100%'}"></textarea>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
    (click)="showBulkEditDialog = false" class="p-button-text"></button>
    <button pButton pRipple type="button" label="Apply" icon="pi pi-check"
      (click)="confirmBulkUpdate()" class="p-button-primary"
    [disabled]="!isBulkEditDataValid()"></button>
  </ng-template>
</p-dialog>

<!-- Sync Breezeway Custom -->
<p-dialog [(visible)]="showSyncBreezewayCustomDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '360px'}" header="Sync Breezeway Tasks" [baseZIndex]="10000" (onHide)="showSyncBreezewayCustomDialog = false">
  <div class="p-fluid">
    <div class="p-field mb-2">
      <label for="customSyncDays" class="fw-bold">Number of days</label>
      <input pInputText id="customSyncDays" type="number" min="1" [(ngModel)]="customSyncDays"
        placeholder="e.g. 45" [style]="{'width':'100%'}" />
        <small class="p-text-secondary">Sync expenses from Breezeway for the last {{customSyncDays}} days.</small>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
      (click)="showSyncBreezewayCustomDialog = false" class="p-button-text"></button>
      <button pButton pRipple type="button" label="Sync" icon="pi pi-refresh"
      (click)="confirmSyncBreezewayCustom()" class="p-button-primary"></button>
    </ng-template>
  </p-dialog>